import {evite} from 'evite';
import './react';
import * as _ReactDom from 'node-modules-react-dom';

Object.assign(exports, _ReactDom);
evite.assert(_ReactDom.findDOMNode, 'Possibly using a minified version of react-dom');
evite.set(evite, 'exports.ReactDom', exports);

window.ReactDom = exports;
